import React from 'react';

interface ChevronDownIconProps {
   className?: string;
   'aria-hidden'?: string | boolean;
}

export const ChevronDownIcon: React.FC<ChevronDownIconProps> = ({ className, 'aria-hidden': ariaHidden }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        className={className || "h-6 w-6"}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
        aria-hidden={ariaHidden === 'true' || ariaHidden === true}
    >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
);